import { ChangeDetectionStrategy, Component, computed, inject, signal } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { FacilityOverviewCardComponent } from './facility-overview-card/facility-overview-card.component';
import { IconButtonComponent, SkeletonDirective } from '@ui-lib/components';
import { AsyncPipe } from '@angular/common';
import { fadeAnimation } from './facilities-overview.animations';
import { TranslateModule } from '@ngx-translate/core';
import { FacilitiesOverviewService } from './facilities-overview.service';
import { LoadingState } from '../../../../shared/types/loading.type';
import { PermissionService } from '../../../../core/services/user/permission.service';
import { UserPermissionEnum } from '../../../../core/models/user-permissions.enum';

@Component({
  selector: 'mon-facilities-overview',
  imports: [
    FacilityOverviewCardComponent,
    IconButtonComponent,
    SkeletonDirective,
    TranslateModule,
    AsyncPipe,
  ],
  templateUrl: './facilities-overview.component.html',
  styleUrl: './facilities-overview.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [fadeAnimation],
  providers: [FacilitiesOverviewService],
})
export class FacilitiesOverviewComponent {
  protected readonly facilitiesOverviewService = inject(FacilitiesOverviewService);
  private readonly permissionService = inject(PermissionService);

  private readonly canReadEquipment = toSignal(
    this.permissionService.hasPermission(UserPermissionEnum.EquipmentRead),
    { initialValue: false },
  );
  private readonly canReadFacilities = toSignal(
    this.permissionService.hasPermission(UserPermissionEnum.FacilityRead),
    { initialValue: false },
  );

  /** Карточка открывает аппараты площадки: нужны список аппаратов и фильтр по площадке. */
  protected readonly canOpenDevices = computed(
    () => this.canReadEquipment() && this.canReadFacilities(),
  );

  protected readonly LoadingState = LoadingState;
  protected readonly PAGE_SIZE = 3;
  protected readonly startIndex = signal(0);
  protected readonly skeletons = new Array(this.PAGE_SIZE);

  public showNext(): void {
    this.startIndex.update((v) => v + this.PAGE_SIZE);
  }

  public showPrev(): void {
    this.startIndex.update((v) => v - this.PAGE_SIZE);
  }
}
